<template>
    <div class="go-top">
        <img @click = "goTop" src="../assets/common/toTop.png"/>
    </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    goTop () {
      window.scroll(0, 0)
    },
    goTopShow () {
      window.addEventListener('scroll', function () {
        const toTop = document.getElementsByClassName('go-top')
        if (document.documentElement.scrollTop > 1000) {
          for (var i = 0; i < toTop.length; i++) {
            toTop[i].style.display = 'block'
          }
        } else {
          for (var d = 0; d < toTop.length; d++) {
            toTop[d].style.display = 'none'
          }
        }
      })
    }
  },
  mounted () {
    this.goTopShow()
  }
}
</script>
<style lang="stylus" scoped>
    .go-top
        width 3rem
        height 3rem
        position fixed
        bottom 2rem
        right 2rem
        z-index 55
        display none
        img
            width 3rem
            cursor pointer
</style>
